import ActionTypes from '@ziynx/action-types';

type AdminActions = {
  type: string,
  id: string,
}

const initialState = {
  newNIL: {
    fetching: false,
    posting: false,
  },
};

export default function reduceNIL(state = initialState, action: AdminActions) {
  if (!action.id) {
    return state;
  }

  switch (action.type) {
  case ActionTypes.NIL.applications.getAll.START:
    return {
      ...state,
      [action?.id]: {
        ...(state[action?.id] || {}),
        fetching: true,
      },
    };
  case ActionTypes.NIL.applications.getAll.SUCCESS:
    return {
      ...state,
      [action?.id]: {
        ...(state[action?.id] || {}),
        ...action?.response,
        results: action?.response?.page > 0
          ? (state[action?.id]?.results ?? []).concat(action?.response?.results ?? [])
          : action?.response?.results,
        fetching: false,
      },
    };
  case ActionTypes.NIL.applications.getAll.ERROR:
    return {
      ...state,
      [action?.id]: {
        ...(state[action?.id] || {}),
        fetching: false,
      },
    };
  default:
    return state;
  }
}
